import {
  EuiFieldText,
  EuiFormRow,
  EuiPanel,
  EuiFieldPassword,
  EuiButton,
} from "@elastic/eui";
import { useState } from "react";
import { useCreateUserMutation } from "../../api/rtkQueryApi/UsersApi";
import {ShowAsPhoneNumber} from "../../utils/Formatters";

export interface IUserCreatePanel {
  onUserCreated?: () => void;
}

export const UserCreatePanel: React.FC<IUserCreatePanel> = (props) => {
  const [email, setEmail] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [createUser, createUserRequest] = useCreateUserMutation();

  const onCreateUserClick = () => {
    createUser({ email, firstName, lastName, password, phoneNumber: ShowAsPhoneNumber(phoneNumber) }).finally(() => {
      props.onUserCreated?.();
    });
  };

  const isValidPassword = (password: string) => {
    return true;
  };

  const isValidPhoneNumber = (phoneNumber: string) => {
    return /^\+?[0-9]*$/.test(phoneNumber) && phoneNumber.length === 10;
  }

  return (
    <EuiPanel>
      <>
        <EuiFormRow label={"Email"}>
          <EuiFieldText
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </EuiFormRow>
        <EuiFormRow label={"Password"}>
          <EuiFieldPassword
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
        </EuiFormRow>
        <EuiFormRow label={"First Name"}>
          <EuiFieldText
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </EuiFormRow>
        <EuiFormRow label={"Last Name"}>
          <EuiFieldText
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </EuiFormRow>
        <EuiFormRow label={"Phone"}>
          <EuiFieldText
              placeholder="+1234567890"
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
              isInvalid={!isValidPhoneNumber(phoneNumber)}
          />
        </EuiFormRow>
        <EuiFormRow>
          <EuiButton
            isDisabled={
              !email || !isValidPassword(password) || !firstName || !lastName || !isValidPhoneNumber(phoneNumber)
            }
            onClick={onCreateUserClick}
            isLoading={createUserRequest.isLoading}
          >
            Create User
          </EuiButton>
        </EuiFormRow>
      </>
    </EuiPanel>
  );
};
